//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import * as userSettingsApi from '@apis/user-settings/userSettingsApi';
import { createNgApiAdapterService, GetNgApiAdapterType } from 'app/angular-apis/createNgApiAdapter';

const userSettingsApiService = createNgApiAdapterService(userSettingsApi);

export type UserSettingsApiServiceType = GetNgApiAdapterType<typeof userSettingsApiService>;

angular.module('curalate').service('UserSettingsApiService', userSettingsApiService);
